import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import API from "../services/api";
import "./login.css";

export default function LoginHotel() {
    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleLogin = async (e) => {
        e.preventDefault();
        setError("");

        try {
            const response = await API.post("/hotel/login", {
                email: email,
                password: password,
            });

            const user = response.data;

            // ✅ IMPORTANT FIX — Store hotelId so surplus can save
            localStorage.setItem("hotelId", user.id);  
            localStorage.setItem("role", "HOTEL");

            navigate("/hotel/dashboard");

        } catch (err) {
            setError("Invalid email or password");
            console.error(err);
        }
    };

   return (
  <div
  className="login-page"
  style={{
    backgroundImage: "url('/images/food-waste.webp')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

    <div className="login-overlay"></div>

    {/* BIG POPUP */}
    <div className="login-popup">
      <h1 className="brand">SaveBite</h1>
      <p className="tagline">Because every plate counts 🍽️</p>

      <form onSubmit={handleLogin} autoComplete="off">
        <input
          type="text"
          placeholder="Hotel Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {error && <div className="error">{error}</div>}

        <button type="submit" className="login-btn">
          Login
        </button>
      </form>

      <div className="register-text">
        Don’t have an account?{" "}
        <Link to="/register">Register</Link>
      </div>
    </div>

    <div className="footer">
      © 2025 SaveBite. All rights reserved.
    </div>
  </div>
);
}